module.exports = __webpack_public_path__ + "static/media/deni-1.f84631fe.jpg";